import script from "./ScoresQuery.vue?vue&type=script&lang=js"
export * from "./ScoresQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__